import { AxiosResponse } from "axios";

export interface RailsError {
    errors: { [id: string]: string[] };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isValidationError<T>(error: any): error is AxiosResponse<T> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return typeof error === "object" && error !== null && error.status === 422;
}
